import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { backendApiV2 } from "../backendApi";
//
import type {
  TelusEnrollPayload,
  SpringHealthEnrollResp,
} from "@neuromotion-inc/mightier-ts-sdk";

type EnrollmentVars = { payload: TelusEnrollPayload };

type EnrollMutationOpts = UseMutationOptions<
  SpringHealthEnrollResp,
  Error,
  EnrollmentVars
>;

export function useTelusEnrollMutation(
  opts: Pick<EnrollMutationOpts, "onSuccess" | "onError">,
) {
  return useMutation({
    ...opts,
    mutationFn: async (vars: EnrollmentVars) => {
      const { payload } = vars;
      const resp = await backendApiV2.telusEnroll(payload);
      return resp.data;
    },
  });
}
